import React, { Component } from 'react'
import { withStyles } 		from 'material-ui/styles'

const styles = {
    table: {
        minWidth: 700,
    },
    tableRow: {
        cursor: 'pointer'
    },
    progressWrapper: {
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    progress: {
    }
};

class Dashboard extends Component {
	constructor(props) {
		super(props);

		this.state = {
			'data' : null,
			'query' : ''
		}
	}

	classes = this.props.classes;

	render() {
		return (
			<div>
				In progress...
			</div>
		)
	}

}

export default withStyles(styles)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/content/Dashboard.js